import { FETCH_WITH_TOKEN } from '@services/react-query/config'
import { GET_SEARCH_SUMMARY_URL } from '@services/react-query/urls/search'
import { useQuery } from '@tanstack/react-query'
import { SearchSummary } from '@type/search'

const useGetSearchSummary = (enabled = false) => {
  const { ...data } = useQuery<SearchSummary[]>({
    queryKey: ['search-summary'],
    queryFn: () => FETCH_WITH_TOKEN(GET_SEARCH_SUMMARY_URL(), true),
    enabled,
  })
  return data
}

export default useGetSearchSummary
